import { api } from '../lib/api'
import type { Quote, OHLCV, Fundamentals, NewsItem, TechnicalIndicators, Signal, MarketIndex, AnalystRatings } from '../types/market'

export interface SearchResult {
  symbol: string
  name: string
  exchange: string
  type: string
}

export const marketApi = {
  prefetch: (symbol: string) =>
    api.get(`/market/prefetch/${symbol}`).catch(() => {}),

  search: (q: string) =>
    api.get<SearchResult[]>('/market/search', { params: { q } }).then((r) => r.data),

  quote: (symbol: string) =>
    api.get<Quote>(`/market/quote/${symbol}`).then((r) => r.data),

  chart: (symbol: string, period: string, interval: string, prepost = false) =>
    api.get<OHLCV[]>(`/market/chart/${symbol}`, { params: { period, interval, ...(prepost ? { prepost: true } : {}) } }).then((r) => r.data),

  vwap: (symbol: string) =>
    api.get<{ time: number; value: number }[]>(`/market/vwap/${symbol}`).then((r) => r.data),

  fundamentals: (symbol: string) =>
    api.get<Fundamentals>(`/market/fundamentals/${symbol}`).then((r) => r.data),

  news: (symbol: string) =>
    api.get<NewsItem[]>(`/news/${symbol}`).then((r) => r.data),

  technicals: (symbol: string, period?: string) =>
    api.get<TechnicalIndicators>(`/technicals/${symbol}`, { params: { period } }).then((r) => r.data),

  signal: (symbol: string) =>
    api.get<Signal>(`/signals/${symbol}`).then((r) => r.data),

  indices: () =>
    api.get<MarketIndex[]>('/market/indices').then((r) => r.data),

  movers: (type: 'gainers' | 'losers') =>
    api.get<Quote[]>(`/market/movers/${type}`).then((r) => r.data),

  analyst: (symbol: string) =>
    api.get<AnalystRatings>(`/market/analyst/${symbol}`).then((r) => r.data),

  shortInterest: (symbol: string) =>
    api.get(`/market/short-interest/${symbol}`).then((r) => r.data),

  shortInterestNews: (symbol: string) =>
    api.get<{ symbol: string; articles: { title: string; url: string; content: string }[] }>(
      `/market/short-interest/${symbol}/news`
    ).then((r) => r.data),
}
